import axios from 'axios';
import { IAviso } from '@/shared/model/aviso.model';

const baseApiUrl = 'api/avisos';

export default class AvisoService {
  public findActivas(): Promise<IAviso[]> {
    return new Promise<IAviso[]>((resolve, reject) => {
      axios.get(`${baseApiUrl}/activas`).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }

  public findAll(): Promise<IAviso[]> {
    return new Promise<IAviso[]>((resolve, reject) => {
      axios.get(baseApiUrl).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }

  public create(entity: IAviso): Promise<IAviso> {
    return new Promise<IAviso>((resolve, reject) => {
      axios.post(baseApiUrl, entity).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }

  public update(entity: IAviso): Promise<IAviso> {
    return new Promise<IAviso>((resolve, reject) => {
      axios.put(`${baseApiUrl}/${entity.id}`, entity).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios.delete(`${baseApiUrl}/${id}`).then(res => resolve(res)).catch(err => reject(err));
    });
  }
}
